
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import './notification.css';

function Notification() {
  return (
    <div className='container-global'>
      <AdminSideBar activeTab="notification" />
      <h1>Notification</h1>
    </div>
  )
}
export default Notification